// extracted by mini-css-extract-plugin
module.exports = {"title-wrapper":"occupation-unit_title-wrapper__aIP_9","bottom-margin":"occupation-unit_bottom-margin__yEIF_","secondary-text":"occupation-unit_secondary-text__8_zfe"};